module.exports = {"rows_per_page":"Files per pàgina","out_of_pages":"de","all":"Totes","search_data":"Buscar dades"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-materialize-datatable/src/locales/cat.json
// module id = K8Ky
// module chunks = 1